import { render, staticRenderFns } from "./AnomaliesTable.vue?vue&type=template&id=f564a928"
import script from "./AnomaliesTable.vue?vue&type=script&lang=js"
export * from "./AnomaliesTable.vue?vue&type=script&lang=js"
import style0 from "./AnomaliesTable.vue?vue&type=style&index=0&id=f564a928&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports